import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DatosActivity } from "../models/activityType";
import { RootState } from "./rootReducer";

export type ActivityReducer = DatosActivity;

const initialState: ActivityReducer = {
  activity: "",
  activityName: "",
  civilState: "",
  partnerDocument: "",
  partnerName: "",
  partnerLastName: "",
  rutNumber: "",
  student: "",
  studentCenter: "",
  studentCenterName: "",
  companyIncome: "",
  startDay: "",
  startMonth: "",
  startYear: "",
  establishmentAddress: {
    department: "",
    city: "",
    street: "",
    number: "",
    apartmentNumber: "",
    additionalInfo: "",
  },
  isMainDomicile: false,
  registeredName: "",
};

export const ActivityReducerState = createSlice({
  name: "Activity",
  initialState,
  reducers: {
    setActivityRedux: (state, action: PayloadAction<ActivityReducer>) => {
      return action.payload;
    },
    setRutNumberRedux: (state, action: PayloadAction<string>) => {
      state.rutNumber = action.payload;
    },
  },
});

export const { setActivityRedux, setRutNumberRedux } = ActivityReducerState.actions;
export const getIsEstablishmentAddressStoredSelector = (state: RootState): boolean => {
  return (
    state.ActivityReducer.isMainDomicile &&
    state.ActivityReducer.establishmentAddress.street &&
    state.ActivityReducer.establishmentAddress.street.length > 0
  );
};

export default ActivityReducerState.reducer;
